import { render, staticRenderFns } from "./MicroCredit.vue?vue&type=template&id=0a3cac09&"
import script from "./MicroCredit.vue?vue&type=script&lang=js&"
export * from "./MicroCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports